import React from "react";
// import Navbar from "../../components/Navbar";
// import BG from "../../assets/img/services/fullNFT/BG.png";
import FNS from "../../assets/img/services/fullNFT/FNS.png";
import spinepro from "../../assets/img/services/fullNFT/SPINEPRO.png";
import spinelogo from "../../assets/img/services/fullNFT/SPINELOGO.png";
import aseprite from "../../assets/img/services/fullNFT/ASEPRITE.png";
import titledlogo from "../../assets/img/services/fullNFT/TITLEDLOGO.png";
// import Footer from "../../components/FooterService";

function FullNFT() {
  return (
    <div>
      <div>
        {/* <Navbar /> */}
        <div className="flex flex-col h-full items-center">
          <div className="flex flex-col lg:flex-row w-[80%] m-auto">
            <div className="w-full lg:w-1/2 ">
              <img
                className="2xl:ml-[5rem] sm:w-[60%] sm:ml-[25%] "
                src={FNS}
                alt=""
              />
            </div>
            <div className="flex items-center justify-center md:w-[78%]">
              <div className="block">
                <div className="text-[14px] lg:text-[24px] font-bold text-white sm:mt-[10%] uppercase mb-5">
                  FULL NFT SUITE
                </div>
                <div>
                  <p className=" text-white  md:text-left break-words lg:w-[90%] mb-5 text-xs md:text-lg">
                    A Non-fungible token (NFT) is a digital asset that is
                    verifiable on blockchain technology. Assets include artwork,
                    music, or in-game assets such as unique avatars. Because
                    they are unique, NFTs are becoming sought after as
                    collectibles.
                  </p>

                  <div className="flex flex-row">
                    <div className="w-full md:w-1/2 mr-4">
                      <img src={spinepro} alt="" className="w-full" />
                    </div>
                    <div className="w-1/3 hidden md:block">
                      <div className="flex flex-col gap-5">
                        <div>
                          <img src={spinelogo} alt="list" width={100} />
                        </div>
                        <div>
                          <img src={aseprite} alt="list" width={100} />
                        </div>
                        <div>
                          <img src={titledlogo} alt="list" width={50} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2 className="fixed -bottom-[12%] font-bold text-[rgba(255,255,255,0.1)] text-[12rem] leading-[140%] tracking-[0.04em] h2Mobile md:block hidden">
          UNIQUE
        </h2>
        {/* <Footer /> */}
      </div>
    </div>
  );
}

export default FullNFT;
